// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Subscription_wrapper__VmyZb","linkList":"Subscription_linkList__23hsf","subscriptionLink":"Subscription_subscriptionLink__2s_vx"};